type Props = {
  className?: string;
};

const WhatsappIcon: React.FC<Props> = ({ className }) => (
  <svg
    className={className}
    version="1.2"
    baseProfile="tiny"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 200 200"
    width="25px"
    height="23px"
  >
    <path
      fill="currentColor"
      d="M145.6 119.9c-2.5-1.2-14.6-7.2-16.9-8.1-2.3-.8-3.9-1.2-5.6 1.2-1.6 2.5-6.4 8.1-7.8 9.7-1.4 1.6-2.9 1.9-5.4.6-2.5-1.2-10.5-3.8-19.9-12.3-7.4-6.6-12.3-14.7-13.8-17.2-1.4-2.5-.2-3.8 1.1-5 1.1-1.1 2.5-2.9 3.7-4.3 1.3-1.4 1.7-2.5 2.5-4.1.8-1.6.4-3.1-.2-4.3-.6-1.2-5.6-13.4-7.6-18.4-2-4.8-4.1-4.2-5.6-4.3l-4.8-.1c-1.6 0-4.3.6-6.6 3.1S50 64.9 50 77.1s8.9 24 10.1 25.6c1.2 1.6 17.5 26.7 42.3 37.4 5.9 2.5 10.5 4.1 14.1 5.2 5.9 1.9 11.3 1.6 15.6 1 4.8-.7 14.6-6 16.7-11.8 2.1-5.8 2.1-10.7 1.4-11.8-.5-1-2.1-1.6-4.6-2.8z"
    />
    <path
      fill="currentColor"
      d="M170.5 29.1C151.8 10.3 126.9 0 100.4 0 45.8 0 1.3 44.5 1.3 99.1c0 17.5 4.6 34.5 13.2 49.5L.5 200 53 186.2c14.5 7.9 30.8 12.1 47.4 12.1 54.6 0 99.1-44.5 99.1-99.1 0-26.5-10.3-51.4-29-70.1zm-70.1 152.4c-17.6 0-31-5-44.9-13.3l-31.2 8.2 8.3-30.4C23.5 131.5 18 117.6 18 99.1c0-45.4 37-82.4 82.4-82.4 45.6 0 82.4 36.9 82.3 82.4.1 45.5-36.9 82.4-82.3 82.4z"
    />
  </svg>
);

export default WhatsappIcon;
